import React, { useState } from 'react';
import { X } from 'lucide-react';
import { sendFrameworkRequest } from '../services/emailService';

const FrameworkDownloadModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Client-side rate limiting / cooldown
    const lastAttempt = localStorage.getItem('last_framework_request_attempt');
    const now = Date.now();
    if (lastAttempt && now - parseInt(lastAttempt) < 60000) { // 1 minute cooldown
      alert('Please wait a moment before requesting again.');
      return;
    }

    setIsSubmitting(true);

    try {
      await sendFrameworkRequest(email);
      localStorage.setItem('last_framework_request_attempt', now.toString());
      setIsSuccess(true);
      setTimeout(() => {
        onClose();
        setIsSuccess(false);
        setEmail('');
      }, 3000);
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Failed to send request. Please try again or contact us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-content-small" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <X size={24} />
        </button>

        {isSuccess ? (
          <div className="modal-success">
            <div className="success-check">✓</div>
            <h3>Request Received</h3>
            <p>The framework overview will be shared shortly via email</p>
          </div>
        ) : (
          <>
            <h2 className="modal-title">Download Framework Overview</h2>
            <p className="modal-subtitle">Enter your email to receive the Adjactive framework documentation</p>

            <form onSubmit={handleSubmit} className="modal-form">
              <div className="form-group">
                <label htmlFor="download-email">Work Email *</label>
                <input
                  type="email"
                  id="download-email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="form-input"
                  placeholder="your@email.com"
                />
              </div>

              <button
                type="submit"
                className="btn-primary btn-full"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : 'Request Framework'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default FrameworkDownloadModal;